import dynaForms from '@elab/core/utils/dynaForms';
import { reduceAction } from '@elab/core/store/helpers';
import { initialState as dynaInitialState } from '@elab/core/utils/dynaForms/reducers';

import types, { storeName } from './types';

export const initialState = state => ({
    ...dynaInitialState(state),
    preferenceGroups: [],
    preferences: {},
    otherGroup: {},
    consentTemplates: [],
    currentSelection: {},
});

const dynaFormReduce = dynaForms.createReducer(storeName);
const reducers = (state = initialState(), action) => {
    state = dynaFormReduce(state, action);

    switch (action.type) {
        case types.SET_PREFERENCE_GROUPS:
            return {
                ...state,
                preferenceGroups: [...(action.payload || [])],
            };
        case types.SET_PREFERENCES:
            return { ...state, preferences: { ...(action.payload || {}) } };
        case types.SET_OTHER_GROUP:
            return { ...state, otherGroup: { ...(action.payload || {}) } };
        case types.SET_CONSENT_TEMPLATES:
            return {
                ...state,
                consentTemplates: [...(action.payload || [])],
            };
        case types.SUBMIT_CURRENT_PREFERENCE:
            return reduceAction(state, 'currentSelection', action.payload);

        default:
            return state;
    }
};

export default reducers;
